export default __webpack_public_path__ + "static/media/plan_c.76e207cd.png";